import {
	ToothRestorationDetail,
	ToothRestorationMaterial,
	ToothRestorationQuality,
} from '../../../../graphql/graphql';

export const RESTORATION_TRANSLATION_MAP = {
	[ToothRestorationMaterial.Composite]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.material.composite',
	[ToothRestorationMaterial.Ceramic]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.material.ceramic',
	[ToothRestorationMaterial.Amalgam]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.material.amalgam',
	[ToothRestorationMaterial.Gold]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.material.gold',
	[ToothRestorationMaterial.NonPreciousMaterial]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.material.nonPreciousMaterial',
	[ToothRestorationMaterial.Temporary]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.material.temporary',
	[ToothRestorationMaterial.GlassIonomer]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.material.glassIonomer',
	[ToothRestorationMaterial.MetalCeramic]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.material.metalCeramic',
	[ToothRestorationDetail.Shortfall]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.detail.shortfall',
	[ToothRestorationDetail.Overhang]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.detail.overhang',
	[ToothRestorationDetail.Flush]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.detail.flush',
	[ToothRestorationQuality.Sufficient]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.quality.sufficient',
	[ToothRestorationQuality.Uncertain]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.quality.uncertain',
	[ToothRestorationQuality.Insufficient]:
		'patientTreatment.meddiDENT.dentalCross.restorationModal.quality.insufficient',
};
